import classnames from 'classnames';

interface Props {
  name: string;
  className?: string;
}

const Name = ({ name, className }: Props) => {
  return (
    <span
      className={classnames(className)}
      style={{
        color: 'var(--name-text-color)',
      }}
    >
      {name}
    </span>
  );
};

export default Name;
